import React, { Component } from "react";
import PropTypes from "prop-types";
import { postScrollHeightToParent } from "../utilities/postMessage";
import handleMessage from "../utilities/messageListener";

class MessagePoster extends Component {
  componentDidMount() {
    window.addEventListener("message", handleMessage);
    window.addEventListener("resize", postScrollHeightToParent);
  }

  componentWillUnmount() {
    window.removeEventListener("message", handleMessage);
    window.removeEventListener("resize", postScrollHeightToParent);
  }

  render() {
    const { children } = this.props;
    return <object aria-label="Learning Materials" onLoad={postScrollHeightToParent}>{children}</object>;
  }
}

MessagePoster.propTypes = {
  children: PropTypes.node.isRequired
};

export default MessagePoster;
